
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 37 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.09 41.473C14.898 38.443 2.134 25.85 2.134 18.091c0-8.799 7.158-15.958 15.958-15.958 8.798 0 15.957 7.16 15.957 15.958 0 7.758-12.763 20.352-15.957 23.382zM18.09 0C8.116 0 0 8.116 0 18.09c0 9.763 16.665 24.988 17.373 25.632a1.066 1.066 0 001.434 0c.71-.643 17.373-15.869 17.373-25.631C36.181 8.116 28.068 0 18.092 0h-.001zm.002 24.948a6.864 6.864 0 01-6.858-6.857 6.863 6.863 0 016.858-6.856 6.864 6.864 0 016.857 6.856 6.865 6.865 0 01-6.857 6.857zm0-15.846c-4.956 0-8.99 4.032-8.99 8.989 0 4.958 4.034 8.99 8.99 8.99 4.957 0 8.99-4.032 8.99-8.99 0-4.956-4.033-8.989-8.99-8.989z","fill":"#000"}})])
          )
        }
      }
    